import React from 'react'
import { PlusOutlined, VideoCameraOutlined } from '@ant-design/icons'
import { Badge, Button, notification, Tag } from 'antd'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'

import { ItemList } from '~components'
import { getCurrentUser } from '~context'
import { PageLayout } from '~stories'

import styles from './VideoContent.module.css'

const PAGE_TITLE = 'Video Contents'
const NOTIFICATION_MESSAGES = {
  UNAUTHORIZED: 'You are not authorized to perform this action.'
}

const getEditLink = record => (
  <a href={`/video-contents/${record._id}/edit`}>
    <Tag className={styles.pageTag} color="geekblue">{record.pageName}</Tag>
  </a>
)

const columnData = [
  {
    dataIndex: 'pageName',
    render: (text, record) => getEditLink(record),
    sorter: true,
    title: 'Page Name',
    width: '35%'
  },
  {
    dataIndex: 'videos',
    render: videos => {
      const count = Array.isArray(videos) ? videos.length : 0
      return (
        <span className={styles.videoBadge}>
          <VideoCameraOutlined style={{ color: '#1890ff' }} />
          <Badge
            count={count}
            showZero
            style={{ backgroundColor: count > 0 ? '#1890ff' : '#bfbfbf' }}
          />
          <span>{count === 1 ? 'video' : 'videos'}</span>
        </span>
      )
    },
    title: 'Videos',
    width: '25%'
  },
  {
    dataIndex: 'updated_at',
    title: 'Updated At',
    width: '30%'
  }
]

const addNewButton = isContentEditor => (
  <Route render={({ history }) => (
    <Button
      key="add-video-cdn"
      icon={<PlusOutlined />}
      onClick={() => {
        isContentEditor
          ? history.push('/video-contents/new')
          : notification.error({ message: NOTIFICATION_MESSAGES.UNAUTHORIZED })
      }}
      type="primary"
    >
      Add Video Content
    </Button>
  )} />
)

const VideoContent = () => {
  const { userDetails: { isContentEditor } } = getCurrentUser()

  return (
    <PageLayout extra={[addNewButton(isContentEditor)]} title={PAGE_TITLE}>
      <div className={styles.container}>
        <ItemList columns={columnData} resource="videoContent" />
      </div>
    </PageLayout>
  )
}

VideoContent.propTypes = {
  message: PropTypes.string,
  status: PropTypes.bool
}

export default VideoContent
